import { Spinner, SpinnerSize } from '@fluentui/react';
import '@ms-mwf/moray/dist/css/main.css';
import * as React from 'react';
import { useShowContactUsAgent } from 'src/hooks/useShowContactUsAgent';
import ContactUsV2BillingSection from '../../components/contactusv2/ContactUsV2BillingSection';
import ContactUsV2Features from '../../components/contactusv2/ContactUsV2Features';
import ContactUsV2GetHelp from '../../components/contactusv2/ContactUsV2GetHelp';
import ContactUsV2GetMoreHelp from '../../components/contactusv2/ContactUsV2GetMoreHelp';
import ContactUsV2SelfHelp from '../../components/contactusv2/ContactUsV2SelfHelp';
import ContactUsV2Success from '../../components/contactusv2/ContactUsV2Success';
import ContactUsV2TopBanner from '../../components/contactusv2/ContactUsV2TopBanner';
import { CopilotAgentCards } from '../../components/copilotkit/CopilotAgentCards';
import { CopilotHeroBar } from '../../components/copilotkit/CopilotHeroBar';
import FollowUsFooter from '../../components/followUsFooter/FollowUsFooter';
import localeService from '../../dataServices/LocaleService';

const ContactUsPageV2: React.FC = () => {
  const { showAgent, isLoading } = useShowContactUsAgent();

  if (isLoading) {
    return (
      <section id="contactus-page">
        <Spinner
          size={SpinnerSize.large}
          label={localeService.getText('Shared', 'SpinnerPleaseWait')}
          ariaLive="assertive"
        />
      </section>
    );
  }

  return (
    <section id="contactus-page">
      <div>
        {showAgent && (
          <>
            <CopilotHeroBar />
            <CopilotAgentCards />
          </>
        )}
        {!showAgent && (
          <>
            <ContactUsV2TopBanner />
            <ContactUsV2Success />
            <ContactUsV2Features />
            <ContactUsV2BillingSection />
            <ContactUsV2GetHelp />
            <ContactUsV2SelfHelp />
            <ContactUsV2GetMoreHelp />
          </>
        )}
        <FollowUsFooter useExternalLinks={true} />
      </div>
    </section>
  );
};

export default ContactUsPageV2;

